const dev = process.env.NODE_ENV === "development";

export const gh_client_id = (dev) ? "fdfdf015e06614eb7a0a" : "ba0ba0140ae29a79bb0e";
export const gh_redirect_url = (dev) ? "http://127.0.0.1:6200/login/" : "https://game.carryout.dev/login/";

export const backendAddress = (dev) ? "http://127.0.0.1:6500" : "https://game-api.carryout.dev:6500";
